import { navLinks } from '../data';

const colFeeds = [
  { label: '聊天记录归档', href: '#archive' },
  { label: '截图留痕', href: '#archive' },
  { label: '线索旁证', href: '#archive' },
  { label: '今日新增', href: '#feed' },
];

const colMore = [
  { label: '事件时间线', href: '#timeline' },
  { label: '热度攀升榜', href: '#rank' },
  { label: '待核实线索', href: '#lead' },
  { label: '投稿说明', href: '#lead' },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <span className="font-heading text-base font-extrabold leading-none">52</span>
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">52爆料</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              以素材为中心的还原聚合站：聊天记录、截图、线索统一编号入库，按类型与时间线检索，细节证据一目了然。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['素材库', '时间线', '热度榜'].map((t) => (
                <span key={t} className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600">
                  #{t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-bold tracking-wide text-foreground-900">站内分区</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-bold tracking-wide text-foreground-900">素材频道</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {colFeeds.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-bold tracking-wide text-foreground-900">快捷导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {colMore.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex gap-2">
              <a href="#top" aria-label="回到顶部" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:text-primary-700">
                <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center" />
              </a>
              <a href="#rank" aria-label="查看热度" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:text-primary-700">
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
              </a>
              <a href="#feed" aria-label="素材流" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:text-primary-700">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-5 text-center">
          <p className="text-xs leading-relaxed text-foreground-500">
            本站素材用于事件还原与信息整理，转载需注明出处并保留编号。涉及个人隐私部分请在投稿时先行隐去。
          </p>
          <p className="mt-3 text-xs text-foreground-500">
            © 2026 52爆料 · 素材 · 证据 · 细节 · 线索
          </p>
        </div>
      </div>
    </footer>
  );
}